// frontend/src/components/DraftRestoreBanner.js
import { Lightning } from '@phosphor-icons/react';

const S = {
  wrap: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '8px 14px', background: 'hsl(43,40%,6%)',
    border: '1px solid hsl(43,80%,25%)', marginBottom: 16,
  },
  left: {
    display: 'flex', alignItems: 'center', gap: 8,
    fontFamily: "'JetBrains Mono', monospace", fontSize: 10,
    color: 'hsl(43,80%,60%)',
  },
  btn: (primary) => ({
    padding: '3px 10px', fontSize: 9, cursor: 'pointer',
    fontFamily: "'JetBrains Mono', monospace", textTransform: 'uppercase',
    letterSpacing: '0.08em',
    background: primary ? 'hsl(43,80%,20%)' : 'transparent',
    border: `1px solid ${primary ? 'hsl(43,80%,35%)' : 'hsl(0,0%,20%)'}`,
    color: primary ? 'hsl(43,90%,65%)' : 'hsl(0,0%,40%)',
  }),
};

/**
 * DraftRestoreBanner — shown when a named draft exists but no UUID was in the URL.
 * Props: hasDraft boolean, onRestore () => void, onDiscard () => void
 */
export default function DraftRestoreBanner({ hasDraft, onRestore, onDiscard }) {
  if (!hasDraft) return null;
  return (
    <div style={S.wrap} data-testid="draft-restore-banner">
      <div style={S.left}>
        <Lightning size={12} weight="bold" />
        You have unsaved work from a previous session.
      </div>
      <div style={{ display: 'flex', gap: 6 }}>
        <button style={S.btn(true)} onClick={onRestore} data-testid="draft-restore-btn">Restore</button>
        <button style={S.btn(false)} onClick={onDiscard} data-testid="draft-discard-btn">Discard</button>
      </div>
    </div>
  );
}
